import getStore from '../store/store';
import { mutator } from 'satcheljs';
import {
    availablePoliciesPageUnmounted,
    resetRetentionPoliciesEdit,
    onAddActivePolicyTagsRequestComplete,
    switchToAvailablePolicies,
} from '../actions/internalActions';

mutator(availablePoliciesPageUnmounted, () => {
    getStore().isUserAtActivePolicies = true;
});

mutator(resetRetentionPoliciesEdit, () => {
    getStore().isUserAtActivePolicies = true;
});

mutator(onAddActivePolicyTagsRequestComplete, () => {
    getStore().isUserAtActivePolicies = true;
});

mutator(switchToAvailablePolicies, () => {
    getStore().isUserAtActivePolicies = false;
});
